import { apiRequest } from './api';

export async function fetchAmbassadeurDashboard() {
  const response = await apiRequest('/ambassadeur/dashboard', { method: 'GET', withAuth: true });
  return response.data;
}

export async function fetchAmbassadeurProfil() {
  const response = await apiRequest('/ambassadeur/profil', { method: 'GET', withAuth: true });
  return response.data;
}

export async function updateAmbassadeurProfil(payload) {
  const response = await apiRequest('/ambassadeur/profil', {
    method: 'PATCH',
    withAuth: true,
    body: JSON.stringify(payload),
  });
  return response.data;
}
